export class TimelineItem {
    title: string;
    time: string;
    text: string;
    icon: string;

    constructor(){
        this.title = null;
        this.time = null;
        this.text = null;
        this.icon = null;
    }
}